import { render } from "./CandidateIcon.vue?vue&type=template&id=bda648d6"
import script from "./CandidateIcon.vue?vue&type=script&lang=js"
export * from "./CandidateIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__